import { createContext } from "react";

const LoginContext = createContext();

export { LoginContext };
